import { render } from "./PactCode.vue?vue&type=template&id=53806476&scoped=true"
import script from "./PactCode.vue?vue&type=script&lang=js"
export * from "./PactCode.vue?vue&type=script&lang=js"

import "./PactCode.vue?vue&type=style&index=0&id=53806476&lang=scss&scoped=true"

import exportComponent from "E:\\hongjia\\Vue\\RedCigar_C_T_Template\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53806476"]])

export default __exports__